import { isTauri } from '@/tauri/utils';
import { logger } from '@/utils/logger/logger';
import { type TranscribeMode } from '@heidi/schema/ml-scribe';

export type ConsentSurface = 'web' | 'desktop';

/**
 * 'web' covers the browser app including Epic Hyperdrive/Hyperspace embedded
 * sessions; 'desktop' is the Tauri shell. Haiku has its own '[HAIKU]' logs.
 */
export function consentSurface(): ConsentSurface {
  return isTauri() ? 'desktop' : 'web';
}

export type ConsentGateDecision = {
  gate: 'recording_v2' | 'recording_v1' | 'recording_button';
  sessionId: string | undefined;
  settingsLoaded: boolean;
  isConsentPopUpSetting: boolean | undefined;
  sessionIsConsent: boolean | null | undefined;
  sessionDuration: number | null | undefined;
  rememberConsent: boolean | null | undefined;
  transcribeMode: TranscribeMode | null | undefined;
  willShowConsentPopup: boolean;
};

/**
 * One line per consent-gate evaluation, mirroring Haiku's
 * '[HAIKU] consent check before recording'. `settingsLoaded:false` with
 * `willShowConsentPopup:false` is the silent no-popup case: the gate cannot
 * know the clinician's setting yet still lets recording start. Behaviour is
 * unchanged; this log makes that case measurable per surface and gate copy.
 */
export function logConsentGateDecision(decision: ConsentGateDecision): void {
  logger.info('[CONSENT] consent check before recording', {
    surface: consentSurface(),
    ...decision,
  });
}
